import React from 'react';
import { FadeIn, Section, SectionLabel } from './UI';
export const SolutionSection = () => {
  return <>
      <Section className="bg-brand-purple text-brand-white" data-id="element-141">
        <FadeIn data-id="element-142">
          <SectionLabel className="!text-brand-pink" data-id="element-143">La solución</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-white mb-5 font-bold" data-id="element-144">
            Guía Digital · <span className="text-brand-pink" data-id="element-145">Ruta USA 360</span>
          </h2>
          <p className="text-white/85 text-[1.1rem] mb-4" data-id="element-146">
            "Aprende a crear tu empresa en EE.UU. paso a paso"
          </p>
          <p className="text-white/75 mb-4 text-[1.05rem]" data-id="element-147">
            No es un curso de 40 horas. No es teoría genérica. Es un{' '}
            <strong data-id="element-148">mapa ejecutable</strong> — para personas que ya quieren
            moverse y solo necesitan saber exactamente cómo.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-9" data-id="element-149">
            {[{
            icon: '✅',
            title: 'Checklist del Proceso',
            desc: 'Cada paso que debes completar, en el orden correcto'
          }, {
            icon: '📋',
            title: 'Requisitos Reales',
            desc: 'Lo que sí necesitas — y lo que nadie te dice que NO necesitas'
          }, {
            icon: '⚠️',
            title: 'Errores a Evitar',
            desc: 'Los errores más comunes que cuestan dinero y tiempo'
          }, {
            icon: '🗺️',
            title: 'Visión 360°',
            desc: 'Entiendes el panorama completo antes de ejecutar'
          }].map((item, i) => <div key={i} className="bg-white/10 border border-white/20 rounded-2xl p-7 text-center" data-id="element-150">
                <span className="text-[2rem] mb-3 block" data-id="element-151">{item.icon}</span>
                <h3 className="font-serif text-[1.1rem] mb-2 text-brand-pink font-bold" data-id="element-152">
                  {item.title}
                </h3>
                <p className="text-[0.9rem] opacity-85 m-0" data-id="element-153">{item.desc}</p>
              </div>)}
          </div>
        </FadeIn>
      </Section>

      <Section className="bg-brand-grayBg" data-id="element-154">
        <FadeIn data-id="element-155">
          <SectionLabel data-id="element-156">Lo que obtienes de verdad</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-157">
            Después de leer Ruta USA 360,
            <br data-id="element-158" />
            <span className="text-brand-purple" data-id="element-159">tu vida se ve así:</span>
          </h2>

          <ul className="mt-7" data-id="element-160">
            {[<>
                <strong className="text-brand-purple" data-id="element-161">Claridad total</strong>{' '}
                sobre qué pasos seguir y en qué orden exacto
              </>, <>
                <strong className="text-brand-purple" data-id="element-162">Confianza</strong> para
                ejecutar sin miedo a equivocarte
              </>, <>
                <strong className="text-brand-purple" data-id="element-163">Tiempo ahorrado</strong> —
                sin más horas de búsqueda infructuosa
              </>, <>
                <strong className="text-brand-purple" data-id="element-164">Dinero protegido</strong>{' '}
                — evitando errores costosos desde el inicio
              </>, <>
                <strong className="text-brand-purple" data-id="element-165">Estructura real</strong>{' '}
                para no perderte en el proceso
              </>, <>
                Tu empresa{' '}
                <strong className="text-brand-purple" data-id="element-166">
                  lista para operar, facturar y crecer legalmente en USA
                </strong>
              </>].map((item, i) => <li key={i} className="flex gap-4 items-start py-[18px] border-b border-brand-border text-[1.05rem]" data-id="element-167">
                <span className="bg-brand-purple text-brand-white w-7 h-7 rounded-full flex items-center justify-center text-[0.85rem] shrink-0 mt-[2px]" data-id="element-168">
                  ✓
                </span>
                <div data-id="element-169">{item}</div>
              </li>)}
          </ul>
        </FadeIn>
      </Section>

      <Section className="bg-white" data-id="element-170">
        <FadeIn data-id="element-171">
          <SectionLabel data-id="element-172">¿Es para ti?</SectionLabel>
          <h2 className="font-serif text-[clamp(1.9rem,4vw,2.8rem)] leading-[1.2] text-brand-dark mb-5 font-bold" data-id="element-173">
            Esta guía es para ti
            <br data-id="element-174" />
            <span className="text-brand-purple" data-id="element-175">si reconoces esto:</span>
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-8" data-id="element-176">
            <div className="bg-[#f0ebf8] border-2 border-brand-purple rounded-2xl p-7" data-id="element-177">
              <h3 className="text-brand-purple mb-4 text-[1rem] tracking-[1px] uppercase font-bold" data-id="element-178">
                ✅ Sí es para ti
              </h3>
              <ul data-id="element-179">
                {['Ya investigaste pero aún tienes dudas', 'Quieres hacerlo bien desde el principio', 'Necesitas ordenar la información', 'Quieres avanzar con seguridad', 'Estás listo para ejecutar esta semana'].map((item, i) => <li key={i} className="py-2 text-[0.97rem] border-b border-black/5 flex items-start gap-2" data-id="element-180">
                    <span className="text-brand-purple font-bold" data-id="element-181">✔</span>{' '}
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-[#fdf2f2] border-2 border-[#e0b0b0] rounded-2xl p-7" data-id="element-182">
              <h3 className="text-[#c0392b] mb-4 text-[1rem] tracking-[1px] uppercase font-bold" data-id="element-183">
                ❌ No es para ti
              </h3>
              <ul data-id="element-184">
                {['Buscas excusas para seguir esperando', 'Quieres más información sin estructura', 'No planeas tomar acción pronto', 'Esperas que alguien lo haga por ti'].map((item, i) => <li key={i} className="py-2 text-[0.97rem] border-b border-black/5 flex items-start gap-2" data-id="element-185">
                    <span className="text-[#c0392b] font-bold" data-id="element-186">✘</span> {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </FadeIn>
      </Section>
    </>;
};